export const inactiveElementStyle = `
  opacity: 0.4;
  pointer-events: none;
`;
